import * as React from "react";
import { useTranslation } from "../../i18n/custom.i18n";
import i18next from "../../i18n/i18n.config";

import {
    LinkContainer,
    LinkBtn,
    LinkAnchor
} from "./LinkStyles";


export const Link = () => {
    const { t, i18n } = useTranslation();

    const open_contact_form = () => {
        const form = document.getElementById("form") as HTMLFormElement;
        
        const form_ta = document.getElementById("form-text-area") as HTMLTextAreaElement;
        form_ta.value = "Hi, I would like to feature my Add-in into RoboDK's Add-in Marketplace. How do we proceed?";
        
        form.submit();
    };

    return (
        <>
            <LinkContainer>
                <form 
                    id="form" 
                    target="_blank"

                    method="post"
                    action="https://robodk.com/contact?contribute-addin"
                >
                    <input 
                        id="form-text-area"
                        className="form-control"
                        type="textarea"
                        name="message"
                        defaultValue="I would like to feature my Add-in into RoboDK's Add-in Marketplace. How should we proceed?"
                        style={{display: "none"}}
                    />

                    <LinkBtn onClick={open_contact_form}>
                        <LinkAnchor>
                            {t('filters-addins.contribute')}
                        </LinkAnchor>
                    </LinkBtn>
                </form>
            </LinkContainer>
        </>
    )
}
